import type { Dispatch, SetStateAction } from 'react'
import { createContext } from 'react'

export type CartContextData = {
  isOpen: boolean
}

export type CartContextType = [
  CartContextData,
  Dispatch<SetStateAction<CartContextData>>,
]

export const CartContext = createContext<CartContextType>([
  {
    isOpen: false,
  },
  () => {
    // noop
  },
])
